import { useSyncExternalStore } from 'react';

const subscribe = () => () => {};

/**
 * False in the build-time prerender and while the browser hydrates that markup,
 * true from the next render on (and from the first render when nothing was
 * prerendered). Anything a render reads that the build cannot know (the clock,
 * prefers-reduced-motion, the query string, first-touch cookies) waits for it,
 * so the hydration pass renders exactly the prerendered tree (GEO S7, #9059).
 */
export function useHydrated(): boolean {
  return useSyncExternalStore(
    subscribe,
    () => true,
    () => false
  );
}
